export const META_REVIEW_SCOPES = [
  "public_profile",
  "email",
  "business_management",
  "whatsapp_business_management",
  "whatsapp_business_messaging",
  "catalog_management",
];

export const createMetaReviewState = () => {
  const state = `meta_review_${Date.now()}_${Math.random()
    .toString(36)
    .slice(2)}`;

  sessionStorage.setItem("metaReviewOAuthState", state);

  return state;
};

export const buildMetaReviewOAuthUrl = ({
  appId,
  redirectUri,
  state,
}: {
  appId: string;
  redirectUri: string;
  state: string;
}) => {
  if (!appId) {
    throw new Error("Missing REACT_APP_META_APP_ID environment variable.");
  }

  const params = new URLSearchParams({
    client_id: appId,
    redirect_uri: redirectUri,
    response_type: "code",
    state,
    scope: META_REVIEW_SCOPES.join(","),
  });

  return `https://www.facebook.com/v21.0/dialog/oauth?${params.toString()}`;
};